import React from 'react'
import Card from '../../components/Card'

export default function () {
	return (
		<div className="flex flex-col text-slate-800 sm:mx-4 sm:my-6 md:mx-32 md:my-12 leading-loose">
			<Card className="flex flex-col">
				<h1 className="text-slate-800 mb-8">Política de Privacidade – ZelAI</h1>

				<p>A ZelAI, comprometida com a ética, a transparência e a segurança das informações, apresenta sua Política de Privacidade, em conformidade com a Lei nº 13.709/2018 – Lei Geral de Proteção de Dados Pessoais (LGPD). Esta política visa esclarecer como coletamos, utilizamos, armazenamos e protegemos os dados pessoais dos nossos usuários, clientes, parceiros e visitantes.</p>

				<p className="font-bold mt-4">1. Quem somos</p>
				<p>A ZelAI é uma empresa especializada em soluções digitais, oferecendo tecnologia de ponta para nossos usuários.</p>

				<p className="font-bold mt-4">2. Coleta de dados pessoais</p>
				<p>Coletamos dados pessoais de forma transparente e legítima, sempre com base em fundamentos legais e com o consentimento do titular, quando necessário.</p>

				<p>Tipos de dados que podemos coletar:</p>
				<p>Nome completo;</p>
				<p>Endereço de e-mail;</p>
				<p>Número de telefone;</p>
				<p>Empresa e cargo;</p>
				<p>Dados de navegação (cookies, IP, geolocalização);</p>
				<p>Outras informações fornecidas voluntariamente pelo usuário em nossos formulários ou interações digitais.</p>

				<p className="font-bold mt-4">3. Finalidade da coleta</p>
				<p>Os dados são coletados com finalidades específicas e legítimas, como:</p>

				<p>Prestação de serviços contratados;</p>
				<p>Comunicação com clientes e usuários;</p>
				<p>Envio de newsletters, ofertas e conteúdos informativos (mediante consentimento);</p>
				<p>Melhorias em nossos produtos e serviços;</p>
				<p>Cumprimento de obrigações legais e regulatórias.</p>

				<p className="font-bold mt-4">4. Compartilhamento de dados</p>
				<p>A ZelAI não comercializa nem compartilha seus dados pessoais com terceiros de forma indiscriminada. O compartilhamento, quando necessário, é realizado de forma segura, apenas com:</p>

				<p>Parceiros que auxiliam na prestação dos serviços contratados;</p>
				<p>Autoridades públicas, mediante obrigação legal ou ordem judicial;</p>
				<p>Plataformas tecnológicas para fins de hospedagem, armazenamento ou marketing (como CRMs e ferramentas de e-mail), sempre em conformidade com esta Política.</p>

				<p className="font-bold mt-4">5. Armazenamento e segurança</p>
				<p>Adotamos as melhores práticas de segurança da informação para proteger os dados pessoais sob nossa guarda, incluindo:</p>

				<p>Criptografia;</p>
				<p>Controle de acesso;</p>
				<p>Monitoramento contínuo;</p>
				<p>Backup regular;</p>
				<p>Ambiente seguro e em conformidade com a LGPD.</p>

				<p>Os dados serão armazenados apenas pelo tempo necessário para cumprir as finalidades para as quais foram coletados ou para atender exigências legais.</p>

				<p className="font-bold mt-4">6. Direitos dos titulares</p>
				<p>Em conformidade com a LGPD, os titulares dos dados pessoais têm os seguintes direitos:</p>

				<p>Confirmação da existência de tratamento;</p>
				<p>Acesso aos dados;</p>
				<p>Correção de dados incompletos, inexatos ou desatualizados;</p>
				<p>Anonimização, bloqueio ou eliminação;</p>
				<p>Revogação do consentimento;</p>
				<p>Informação sobre compartilhamento com terceiros;</p>
				<p>Oposição ao tratamento realizado com base em interesse legítimo.</p>

				<p>Para exercer seus direitos, envie uma solicitação para: <a href="mailto:suporte@zelai.com.br">suporte@zelai.com.br</a></p>

				<p className="font-bold mt-4">7. Cookies e tecnologias de rastreamento</p>
				<p>Utilizamos cookies e tecnologias similares para melhorar a experiência de navegação, analisar padrões de uso e personalizar conteúdos. O usuário pode, a qualquer momento, gerenciar suas preferências de cookies em seu navegador.</p>

				<p className="font-bold mt-4">8. Alterações nesta política</p>
				<p>Esta Política de Privacidade pode ser atualizada a qualquer momento para refletir melhorias ou adequações legais. Recomendamos a leitura periódica desta seção.</p>

				<p>A data da última atualização será sempre indicada no final do documento.</p>

				<p className="font-bold mt-4">9. Contato</p>
				<p>Em caso de dúvidas, solicitações ou reclamações sobre esta Política ou o tratamento dos seus dados pessoais, entre em contato através do nosso e-mail:</p>

				<p className="mt-8">E-mail: <a href="mailto:suporte@zelai.com.br">suporte@zelai.com.br</a></p>

				<p className="mt-8 self-end">Data da última atualização: 12/06/2025</p>
			</Card>
		</div>
	)
}
